import { ICosmosModel, IInstallmentsPriceForTable, ILabel, IProduct, ITpackage } from "./types";

export default class Product implements IProduct {

  public id: number;
  public phoneId: string;
  public model: string;
  public desc: string;
  public productLine: {
    id: number,
    productLine: string;
    name: string;
  };
  public manufacturer: {
    id: number,
    name: string;
  };
  public status: number;
  public sellCosmos: boolean;
  public sellSubsidy: boolean;
  public sellTelenorHome: boolean;
  public sellWithoutContractObligation: boolean;
  public cosmosSpecial: boolean;
  public productGroup: any;
  public groupMaster: number | boolean;
  public assignedTariffPackage: ITpackage;
  public tariffPackages: ITpackage[];
  public outlet: boolean;
  public label: ILabel;
  public productImages: any;
  public productColorsImages: any;
  public productCharacteristics: any[];
  public productPrices: any;
  public promoUrl: string | null;
  public prices: {
    displayPrice: string | number;
    displayCreditPrice: string | number;
    displayCreditPriceInRate: string | number;
    displayCreditOldPriceInRate: string | number;
    displayCreditRate: string | number;
    displayInstallmentsPriceForTable: IInstallmentsPriceForTable[];
  };
  public specifications: any[];
  public productListSticker: null | any[];
  public productOverviewSticker: null | any[];
  public specificationImage: null | any[];
  public cosmosModel: ICosmosModel[];
  public generalFlags: {
    withInsurance: boolean;
  };
  public erpCode: string;
  public bundles: any;
  public cosmosTariffPackages: ITpackage[];
  public subsidyTariffPackages: ITpackage[];
  public greenVoucherDiscount?: number;
  public ebillDiscount?: number;
  public showDiscountSticker: boolean;

  constructor(
    id: number,
    phoneId: string,
    model: string,
    desc: string,
    productLine: { id: number; productLine: string, name: string },
    manufacturer: { id: number; name: string },
    status: number,
    sellCosmos: boolean,
    sellSubsidy: boolean,
    sellTelenorHome: boolean,
    sellWithoutContractObligation: boolean,
    cosmosSpecial: boolean,
    productGroup: any,
    groupMaster: number | boolean,
    assignedTariffPackage: ITpackage,
    tariffPackages: ITpackage[],
    outlet: boolean,
    label: ILabel,
    productImages: any[],
    productColorsImages: any[],
    productCharacteristics: any[],
    productPrices: any,
    promoUrl: string | null,
    prices: {
      displayPrice: string | number;
      displayCreditPrice: string | number;
      displayCreditPriceInRate: string | number;
      displayCreditOldPriceInRate: string | number;
      displayCreditRate: string | number;
      displayInstallmentsPriceForTable: IInstallmentsPriceForTable[];
    },
    specifications: any[],
    productListSticker: null | any[],
    productOverviewSticker: null | any[],
    specificationImage: null | any[],
    cosmosModel: ICosmosModel[],
    generalFlags: {
      withInsurance: boolean,
    },
    erpCode: string,
    bundles: any,
    cosmosTariffPackages: ITpackage[],
    subsidyTariffPackages: ITpackage[],
    greenVoucherDiscount: number | undefined,
    ebillDiscount: number | undefined,
    showDiscountSticker: boolean,
  ) {
    this.id = id;
    this.phoneId = phoneId;
    this.model = model;
    this.desc = desc;
    this.productLine = productLine;
    this.manufacturer = manufacturer;
    this.status = status;
    this.sellCosmos = sellCosmos;
    this.sellSubsidy = sellSubsidy;
    this.sellTelenorHome = sellTelenorHome;
    this.sellWithoutContractObligation = sellWithoutContractObligation;
    this.cosmosSpecial = cosmosSpecial;
    this.productGroup = productGroup;
    this.groupMaster = groupMaster;
    this.assignedTariffPackage = assignedTariffPackage;
    this.tariffPackages = tariffPackages;
    this.outlet = outlet;
    this.label = label;
    this.productImages = productGroup;
    this.productColorsImages = productColorsImages;
    this.productCharacteristics = productCharacteristics;
    this.productPrices = productPrices;
    this.promoUrl = promoUrl;
    this.prices = prices;
    this.specifications = specifications;
    this.productListSticker = productListSticker;
    this.productOverviewSticker = productOverviewSticker;
    this.specificationImage = specificationImage;
    this.cosmosModel = cosmosModel;
    this.generalFlags = generalFlags;
    this.erpCode = erpCode;
    this.bundles = bundles;
    this.cosmosTariffPackages = cosmosTariffPackages;
    this.subsidyTariffPackages = subsidyTariffPackages;
    this.greenVoucherDiscount = greenVoucherDiscount;
    this.ebillDiscount = ebillDiscount;
    this.showDiscountSticker = showDiscountSticker;
  }

}
